import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { UncontrolledTooltip, Modal, ModalBody, FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape } from 'react-intl';
import { number, string, bool } from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';
import Hint from '@components/Hint/Hint';
import PreviewPopover from '../Preview/PreviewPopover';
import CustomControl from '@components/CustomControl/CustomControl';
import LandingDownloadChooseFlowBlock from './LandingDownloadChooseFlowBlock';
import { STATIC_PATH } from '../../config';
import SVG from 'react-inlinesvg';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  url: string.isRequired,
  name: string.isRequired,
  totalCr: number.isRequired,
  totalEpC: number.isRequired,
  adaptive: number.isRequired,
  intl: intlShape.isRequired,
  isTop: bool,
  maxCrLandingId: number,
  tiktok: number,
};

const defaultProps = {
  name: 'landings',
};

const checkMobileString = (title) => /мобил|mobil/.test(title.toLowerCase());

const getString = (intl, id, defaultMessage) => intl.formatMessage({ id, defaultMessage });

const getResponsiveTooltip = (isAdaptive, title) => {
  if (isAdaptive) {
    return <FMessage id="tooltip.title.responsive" />;
  } else if (checkMobileString(title)) {
    return <FMessage id="tooltip.title.mobile" />;
  }

  return <FMessage id="tooltip.title.non-responsive" />;
};

const OfferLandingsTableItem = ({
  id,
  title,
  totalCr,
  totalEpC,
  adaptive,
  name,
  url,
  offerId,
  isMyOffer,
  offer,
  site_key,
  connectOffer,
  intl,
  maxCrLandingId,
  tiktok,
  available,
  spForm,
}) => {
  const {
    modifies: { is_cdn, g },
  } = offer;
  const [previewPopoverIsOpen, togglePreviewPopover] = useState(false);
  const [downloadModalIsOpen, toggleDownloadModal] = useState(false);
  const togglePreview = () => togglePreviewPopover(!previewPopoverIsOpen);
  const toggleDownload = () => toggleDownloadModal(!downloadModalIsOpen);

  const containerRef = useRef(null);

  useEffect(() => {
    document.addEventListener('mousedown', closePopoverOnClickOutside);

    return () => {
      document.removeEventListener('mousedown', closePopoverOnClickOutside);
    };
  }, []);

  const closePopoverOnClickOutside = (e) => {
    if (!containerRef.current.contains(e.target)) {
      togglePreviewPopover(false);
    }
  };

  const renderDownloadModal = () => (
    <Modal size="md" isOpen={downloadModalIsOpen} toggle={toggleDownload}>
      <ModalBody className="landing-download-modal">
        <LandingDownloadChooseFlowBlock
          offer={offer}
          landingId={id}
          site_key={site_key}
          connectOffer={connectOffer}
          name={name}
          closeFn={() => toggleDownloadModal(false)}
        />
      </ModalBody>
    </Modal>
  );
  return (
    <tr>
      <td className="platform">
        <span id={`${name}_${id}`} className="platform__controls">
          <SVG
            src={`${STATIC_PATH}/img/action-icons/desktop_icon.svg`}
            height="24"
            width="24"
            cacheRequests
            className={cn('landing-icon', {
              'is-active': !checkMobileString(title),
            })}
          />
          <SVG
            src={`${STATIC_PATH}/img/action-icons/mobile_icon.svg`}
            height="24"
            width="24"
            cacheRequests
            className={cn('landing-icon', {
              'is-active': adaptive > 0 || checkMobileString(title),
            })}
          />
          {/* OFFERRUM-2406 */}
          {/* <FormGroup className="sp-enable"> */}
          {/*<CustomControl*/}
          {/*  id={`sp_check-${id}`}*/}
          {/*  className="custom-control-xs no-margin"*/}
          {/*  value={id}*/}
          {/*  onChange={() => console.log('hello world')}*/}
          {/*  checked={false}*/}
          {/*  disabled={!available}*/}
          {/*  inline*/}
          {/*/>*/}
          {/* {spForm ? (
              <Hint id={`offer-top-landing-hint-${id}`} placement="right" delay={250}>
                <FormattedHTMLMessage
                  id="offer.top-landing.hint-1"
                  defaultMessage="Work through the form of payment is allowed only with agreed landing pages."
                  tagName="p"
                />
              </Hint>
            ) : null} */}
          {/* </FormGroup> */}
        </span>

        {/*<UncontrolledTooltip*/}
        {/*  placement="right"*/}
        {/*  target={`${name}_${id}`}*/}
        {/*  delay={{ show: 250, hide: 250 }}*/}
        {/*>*/}
        {/*  {getResponsiveTooltip(adaptive, title)}*/}
        {/*</UncontrolledTooltip>*/}
      </td>
      <td className="landings-item-title">
        <span className="landings-item-title-inner">
          <a href={url} target="_blank">
            {title}
          </a>

          {/* {isTop && ( */}
          {/* OFFERRUM-1781 attach badge to landing with max Cr */}
          {maxCrLandingId === id && (
            <span className="landings-item-badge landings-item-badge--top">
              <FormattedMessage id="offer.top-link.badge" defaultMessage="Top" />
            </span>
          )}
          {tiktok ? (
            <span className="landings-item-badge landings-item-badge--tiktok">TikTok</span>
          ) : null}
        </span>
      </td>
      {!g && (
        <td className="text-right">{totalCr === 0 ? '—' : totalCr > 100 ? '>100' : totalCr}</td>
      )}
      <td className="text-right" ref={containerRef}>
        {isMyOffer && (
          <div
            className="preview-landing-link"
            onClick={togglePreview}
            id={`preview-landing-link-${id}`}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/eye_icon.svg`}
              height="24"
              width="24"
              cacheRequests
            />
            <PreviewPopover
              target={`preview-landing-link-${id}`}
              id={id}
              offerId={offerId}
              toggle={togglePreview}
              isOpen={previewPopoverIsOpen}
            />
          </div>
        )}
      </td>
      <td>
        {/* OFFERRUM-2406 */}
        {!available ? (
          <Link
            className="btn btn-sm btn-primary"
            to={`/tickets/create?theme=RequestForAccessToTheSpOffer`}
          >
            <FormattedMessage id="offer.top-link.get-access-btn" defaultMessage="Top" />
          </Link>
        ) : null}
      </td>
      {is_cdn ? (
        <td>
          <Icon
            type="download"
            className="download-landing-link"
            id={`download-landing-link-${id}`}
            onClick={toggleDownload}
            title={getString(intl, 'offer.landings-table.download-archive', 'Download archive')}
          />
        </td>
      ) : null}
      {renderDownloadModal()}
    </tr>
  );
};

OfferLandingsTableItem.propTypes = propTypes;
OfferLandingsTableItem.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  offerId: state.offers.selected.id,
  isMyOffer: state.offers.selected.modifies.is_my,
});

export default connect(mapStateToProps)(injectIntl(OfferLandingsTableItem));
